import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { confirm } from '../../confirm/Confirm';

interface DeleteButtonProps {
    onDelete: () => void;
}

export function DeleteButton({ onDelete }: DeleteButtonProps): JSX.Element {
    return (
        <button
            className="text-error relative -top-10 ml-auto flex w-auto items-center gap-2"
            type="button"
            aria-label={gettext('DELETE')}
            data-testid="DeleteAllBlocksButton"
            onClick={() =>
                confirm({
                    message: gettext('DELETE_TEMPLATE'),
                    onConfirm: onDelete,
                })
            }
        >
            <FontAwesomeIcon icon={faTrash} className="h-4 w-4" size="sm" />
            <span>{gettext('DELETE_TEMPLATE')}</span>
        </button>
    );
}
